import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import styled from "@emotion/styled"
import ImageChirurgien from "../components/imageChirurgien"
import ImageSurMesure from "../components/imageSurMesure"
import ImageTechniques from "../components/imageTechniques"
import ImageConventionne from "../components/imageConventionne"
import SEO from "../components/seo"
import Share from "../components/share"
import { Helmet } from "react-helmet"

const IndexPage = () => (
  <Layout pathEn="/en/overview/">
    <SEO
      title="Chirurgien de la main, du coude et de l’épaule à Paris - Dr Roure"
      description="Chirurgien orthopédiste à Paris 7 spécialiste du membre supérieur, Dr Philippe Roure exerce la
      chirurgie de la main, du coude, de l'épaule et du poignet."
    />
    <Helmet>
      <meta
        property="og:url"
        content="https://www.docteurphilipperoure.com/chirurgien-main-coude-epaule-paris/"
      />
      <meta
        property="og:title"
        content="Chirurgien de la main, du coude et de l’épaule à Paris - Dr Roure"
      />
      <meta
        property="og:description"
        content="Chirurgien orthopédiste à Paris 7 spécialiste du membre supérieur, Dr Philippe Roure exerce la
        chirurgie de la main, du coude, de l'épaule et du poignet."
      />
      <meta property="og:locale" content="fr_FR" />
      <meta
        property="og:image"
        content="https://www.docteurphilipperoure.com/chirurgie-membre-superieur.jpg"
      />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="fb:app_id" content="1086796511711258" />
      <link
        rel="alternate"
        hreflang="en"
        href={`https://www.docteurphilipperoure.com/en/overview/`}
      />
    </Helmet>
    <ImageChirurgien />
    <WrapperTitle>
      <Breadcrumb>
        <Link to="/">Accueil </Link>
      </Breadcrumb>
      <H1>
        Dr Philippe Roure, Chirurgien de la main, du coude et de l’épaule à
        Paris
      </H1>
      <p className="intro">
        Chirurgien spécialisé en chirurgie orthopédique et réparatrice, avec
        plus de 20&nbsp;ans d’expérience en tant que chirurgien spécialiste du
        membre supérieur, le Dr Philippe Roure exerce de manière exclusive la
        chirurgie de la main, du coude, de l'épaule et du poignet à Paris. Il
        est diplômé en microchirurgie, en chirurgie du sport et en chirurgie de
        la main.
      </p>
    </WrapperTitle>

    <Wrapper>
      <Row>
        <Col1>
          <H2>
            Une approche <span>sur-mesure</span> de la chirurgie
          </H2>
          <p>
            Le Dr Philippe Roure privilégie une approche « sur mesure » de la{" "}
            <Link to="/chirurgie-main/">chirurgie orthopédique de la main</Link>
            , du <Link to="/chirurgie-coude/">coude</Link> et de l’
            <Link to="/chirurgie-epaule/">épaule</Link>, recherchant à la fois
            la solution techniquement la plus pointue et la 
            <strong>mieux adaptée aux attentes</strong> et au profil de ses
            patients.
          </p>
          <p>
            Il allie son expérience de la prise en charge des sportifs de haut
            niveau à celle de la chirurgie réparatrice et de la microchirurgie
            afin de proposer une <strong>réponse personnalisée</strong> à chacun
            de ses patients.
          </p>
          <p>
            Ses <strong>20 ans d’expérience</strong> en tant que chirurgien
            exclusif du membre supérieur, de la main et de l’épaule lui donnent
            le recul nécessaire afin de proposer à ses patients les solutions
            les plus pertinentes.
          </p>

          <p>
            Il réalise <strong>personnellement</strong> l’ensemble de ses
            interventions et assure lui-même le 
            <strong>suivi post-opératoire</strong> de tous ses patients.
          </p>
        </Col1>
        <Col2>
          <ImageSurMesure />
        </Col2>
      </Row>

      <Row>
        <Col3>
          <ImageTechniques />
        </Col3>
        <Col4>
          <H2>
            Des <span>techniques récentes</span> et mini-invasives
          </H2>
          <p>
            Le Dr Roure utilise pour ses interventions les techniques les plus
            récentes et les moins invasives, faisant appel en particulier à la {" "}
            <Link to="/techniques/microchirurgie/">microchirurgie</Link> et l’
            <Link to="/techniques/arthroscopie/">arthroscopie</Link>. Ces
            techniques lui permettent de{" "}
            <strong>limiter au mieux les douleurs</strong> et l'indisponibilité
            post-opératoires, tout en apportant un{" "}
            <strong>résultat  fonctionnel et esthétique</strong> optimal.
          </p>
          <p>
            Il assure ses consultations ainsi que ses interventions
            chirurgicales au sein de centres parisiens hyperspécialisés dans la
            chirurgie orthopédique et la chirurgie du sport : {" "}
            <Link to="/consultation/">l’Espace Médical Vauban</Link> (Paris 7
            <sup>eme</sup>
            arrondissement) et la{" "}
            <Link to="/hospitalisation/">Clinique du Sport</Link> (Paris 5
            <sup>ème</sup> arrondissement). Il dispose ainsi du matériel médical
            et chirurgical le plus moderne avec les{" "}
            <strong>standards de sécurité et de qualité</strong> les plus
            élevés, en collaboration avec des confrères également spécialisés
            dans la traumatologie, la médecine du sport et la chirurgie
            orthopédique.
          </p>
        </Col4>
      </Row>

      <Row>
        <Col5>
          <H2>
            Un chirurgien d’<span>expérience</span> et{" "}
            <span>hyperspécialisé</span>
          </H2>
          <p>
            Exerçant en tant que{" "}
            <Link to="/chirurgie-main/">chirurgien de la main</Link> et du
            membre supérieur{" "}
            <strong>secteur libéral privé depuis 20&nbsp;ans</strong>, le Dr
            Roure est conventionné avec honoraires libres auprès des caisses de
            sécurité sociale (secteur 2). Afin de conserver toute son
            indépendance ainsi que la liberté d’utiliser les techniques
            chirurgicales qu’il estime les plus adaptées, il n’est pas adhérent
            aux contrats <strong>OPTAM/ OPTAM CO</strong> proposés par les
            caisses de sécurité sociale.
          </p>
          <p>
            Si votre mutuelle complémentaire ne vous couvre pas suffisamment
            pour vos frais chirurgicaux, une partie des honoraires peut rester à{" "}
            <strong>votre charge</strong>. Son assistante Paula vous assistera
            au mieux pour faire le point sur votre couverture. Un 
            <strong>devis détaillé</strong> vous sera systématiquement remis
            avant toute intervention.
          </p>
          <p>
            Le Dr Philippe Roure est inscrit au tableau du conseil départemental
            de l’ordre des médecins de la ville de Paris sous le N°&nbsp;73755,
            N° RPPS 10000832088. Il exerce au sein de la SELARL PHILIPPE ROURE,
            448029561 RCS Paris, dont il est le gérant.
          </p>
        </Col5>
        <Col6>
          <ImageConventionne />
        </Col6>
      </Row>

      <H3>
        Titres & <span>formations</span>
      </H3>
      <Row>
        <Col>
          <Ul>
            <Li>
              Diplômé du DESC de chirurgie orthopédique et traumatologique.
            </Li>
            <Li>Droit au titre de chirurgien de la main</Li>
            <Li>Ancien chef de clinique à la Faculté de Médecine de Paris</Li>
            <Li>
              Ancien assistant à l’hôpital Boucicaut et à l’hôpital Européen
              Georges Pompidou
            </Li>
            <Li>Ancien attaché à l’Hôpital Européen Georges Pompidou</Li>
            <Li>Ancien Interne des hôpitaux de Paris</Li>
            <Li>Lauréat de la faculté de Médecine de Paris</Li>
            <Li>
              Ancien attaché de recherche à Hong Kong University et assistant au
              Queen Mary Hospital de Hong Kong
            </Li>
          </Ul>
        </Col>

        <Col>
          <Ul>
            <Li>
              Diplôme Universitaire de chirurgie de la Main et du Membre
              supérieur, Université Paris VII
            </Li>
            <Li>
              Diplôme Universitaire de Microchirurgie, Université Paris XIII
            </Li>
            <Li>
              Diplôme Universitaire de Chirurgie du Sport, Université Paris VI
            </Li>
            <Li>
              Diplôme Universitaire d’anatomie fonctionnelle et chirurgicale de
              l’appareil locomoteur, Université Paris V
            </Li>
            <Li>Membre de la Société Française d’arthroscopie</Li>
            <Li>
              Membre associé de la société Française de Chirurgie de la Main
            </Li>
            <Li>
              Membre du Groupe Européen d’Étude de l’Arthroscopie du Poignet
            </Li>
            <Li>Membre de la Société Française des Services Urgence Main</Li>
          </Ul>
        </Col>
      </Row>

      <H3>
        <span>Parutions</span> scientifiques
      </H3>

      <Ul>
        <Li>
          P. Roure, D. Fontès, J.-M. Cognet, «&nbsp;Arthroscopie des
          articulations de la main. Installations, voies d’abord et
          pathologies&nbsp;», <i>L’Arthroscopie</i>, SFA, Potel J.F, Hulet C,
          Elsevier Masson, 2015, pp.&nbsp;650-656.
        </Li>

        <Li>
          J.-M. Cognet, P. Roure, M. Levadoux, «&nbsp;Ostéosynthèse des
          fractures articulaires du radius distal sous arthroscopie&nbsp;»,{" "}
          <i>L’Arthroscopie</i>, SFA, Potel J.F, Hulet C, Elsevier Masson, 2015,
          pp.&nbsp;570-583.
        </Li>

        <Li>
          J.-M. Cognet, M. Levadoux, P. Roure, X. Martinache, «&nbsp;Syndrome du
          canal carpien. Traitement endoscopique, indications et
          résultats&nbsp;», <i>L’Arthroscopie</i>, SFA, Potel J.F, Hulet C,
          Elsevier Masson, 2015, pp.&nbsp;632-649.
        </Li>

        <Li>
          P. Roure, N. Lefevre, S. Herman, D. Fontes, «&nbsp;Notre expérience de
          l’ostéoynthèse par plaque ITS des fractures du 1/3 moyen de la
          clavicule&nbsp;»,{" "}
          <i>
            La ceinture claviculo-scapulaire : actualités thérapeutiques. 3èmes
            rencontres de l’IMM
          </i>
          , Allieu Y. Sauramps Medical 2010, pp.&nbsp;87-92.
        </Li>

        <Li>
          P. Roure, D. Fontes, «&nbsp;Les lésions articulaires de la main du
          rugbyman&nbsp;», <i>Journal de Traumatologie du Sport</i>, 2007, 24,
          pp.&nbsp;172-175.
        </Li>

        <Li>
          P. Roure, D. Fontes, «&nbsp;Complication et prévention de
          l’arthroscopie du membre supérieur&nbsp;»,{" "}
          <i>Chirurgie de la Main, n25</i>, 2006, pp.&nbsp;S274-S279.
        </Li>

        <Li>
          P. Roure, D. Fontes, «&nbsp;Apport de l’arthroscopie au niveau de
          l’articulation trapézo-métacarpienne&nbsp;»,{" "}
          <i>Journal de Traumatologie du Sport</i>, 2005, 22, pp.&nbsp;243-245.
        </Li>

        <Li>
          P. Roure, D. Fontes, «&nbsp;Aux limites de l’arthroscopie : le canal
          carpien endoscopique, l’aponévrotomie endoscopique de
          l’avant-bras&nbsp;», in Rodineau J, Saillant G. Masson,{" "}
          <i>Arthroscopie thérapeutique en traumatologie du sport</i>, 2005,
          pp.&nbsp;147-154.
        </Li>

        <Li>
          P. Roure, D. Fontes, «&nbsp;Articulation trapézo-métacarpienne et
          articulations des doigts : apport de l’arthroscopie&nbsp;», in
          Rodineau J., Saillant G. Masson,{" "}
          <i>Arthroscopie thérapeutique en traumatologie du sport</i>, 2005,
          pp.&nbsp;137-146.
        </Li>

        <Li>
          P. Roure, D. Fontes, «&nbsp;Apports de l’arthroscopie dans le
          traitement des fractures articulaires du radius chez le sujet
          jeune&nbsp;», in Rodineau J., Saillant G. Masson,{" "}
          <i>Arthroscopie thérapeutique en traumatologie du sport</i>, 2005,
          pp.&nbsp;109-116.
        </Li>

        <Li>
          P. Roure, D. Fontes, «&nbsp;Apports actuels de l’arthroscopie dans la
          pathologie du poignet&nbsp;»,{" "}
          <i>Index Orthopédie-Traumatologie du sport</i>, 2005, vol 2, n4,
          pp.&nbsp;5-15.
        </Li>

        <Li>
          P. Roure, D. Fontes, «&nbsp;Apports de l’arthroscopie dans la
          pseudarthrose du scaphoide,&nbsp;», in Lussiez B., Rizzo C., Lebreton
          E., <i>Le scaphoide, de la fracture à l’arthrose</i>, Sauramps med,
          2004, pp.&nbsp;357-364.
        </Li>

        <Li>
          P. Roure, D. Fontes, «&nbsp;Le poignet arthrosique du sportif : les
          séquelles de fractures&nbsp;», in Landreau P, Garçon P.,{" "}
          <i>Sport et cartilage</i>, Med line Ed., 2004, pp.&nbsp;165-175.
        </Li>

        <Li>
          P. Roure, A. C. Masquelet, «&nbsp;Étude anatomique du coussin
          graisseux sus-rétinaculaire : application à l’abord chirurgical du
          canal carpien&nbsp;», <i>Chirurgie de la main</i>, 2001, vol 20, 4,
          pp.&nbsp;287-293.
        </Li>

        <Li>
          P. Roure, B. Barbato, «&nbsp;Conduite à tenir en urgence devant une
          lésion pulpaire des doigts&nbsp;», <i>Maîtrise Orthopédique</i>,
          n°103, pp.&nbsp;14-16.
        </Li>

        <Li>
          P. Roure, «&nbsp;5eme cours de chirurgie de l’épaule de Balgrist,
          Zürich&nbsp;», <i>Maîtrise Orthopédique</i>, n°89, pp.&nbsp;24-27.
        </Li>

        <Li>
          P. Roure, W. Y. Ip, W. Lu, S.P. Chow, S. Gogolewski,
          «&nbsp;Intramedullary fixation by resorbable rods in a comminuted
          phalangeal fracture model&nbsp;», <i>Journal of Hand Surgery</i>, 24B
          : 4, pp.&nbsp;476-481.
        </Li>

        <Li>
          P. Roure, «&nbsp;Bons Baisers de Hong-Kong, région administrative
          spéciale de la République Populaire de Chine&nbsp;»,{" "}
          <i>Maîtrise Orthopédique</i>, 1999, n°81, pp.&nbsp;14-19.
        </Li>

        <Li>
          P. Roure. (1999). «&nbsp;La cicatrisation dirigée&nbsp;»,{" "}
          <i>Développement et santé</i>, n°144, pp.&nbsp;28-30.
        </Li>
      </Ul>
      <Share
        slug="https://www.docteurphilipperoure.com/consultation/"
        title="Consultation de chirurgie orthopédique - Dr Philippe Roure"
      />
    </Wrapper>
  </Layout>
)

export default IndexPage

const WrapperTitle = styled.div`
  background-color: white;
  width: 78%;
  margin: 0 auto;
  border-radius: 7px;
  padding: 1.5em 2em 0.9em;
  margin-bottom: 45px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px;
  @media (max-width: 1024px) {
    width: 100%;
    box-sizing: border-box;
    padding: 1em 1em 0.5em;
  }
`
const Breadcrumb = styled.div`
  text-align: center;
  font-size: 0.9em;
  line-height: 1em;
  font-weight: 400;
  a {
    color: #919090;
    text-decoration: none;
  }
  @media (max-width: 678px) {
    font-size: 0.87em;
    margin-bottom: 10px;
  }
`

const H1 = styled.h1`
  font-size: 2.1em;
  @media (max-width: 678px) {
    font-size: 1.82em;
    line-height: 1.1em;
  }
`

const H2 = styled.h2`
  font-weight: 400;
  line-height: 1.38em;
  font-size: 1.72em;
  margin-block-start: 0;
  span {
    font-weight: 800;
  }
  @media (max-width: 678px) {
    font-size: 1.7em;
    line-height: 1.3em;
  }
`

const H3 = styled.h3`
  text-align: center;
  font-weight: 400;
  line-height: 1.38em;
  font-size: 2.1em;
  margin-bottom: 0.4em;
  span {
    font-weight: 700;
  }
  @media (max-width: 678px) {
    font-size: 2em;
    margin-top: 0;
  }
`

const Wrapper = styled.div`
  background-color: white;
  border-radius: 5px;
  margin: 0.5em auto 0.5em;
  padding: 2.25em 2em 1em 2em;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px;
  @media (max-width: 678px) {
    border-radius: 0;
    padding: 1em;
  }
`

const Row = styled.div`
  display: flex;
  margin: 0px 0 55px;
  clear: both;
  @media (max-width: 678px) {
    flex-wrap: wrap;
    margin: 0px 0 25px;
  }
`

const Col = styled.div`
  flex: 50%;
  @media (max-width: 678px) {
    flex-basis: 100%;
  }
`

const Col1 = styled.div`
  flex: 50%;
  @media (max-width: 678px) {
    flex-basis: 100%;
  }
`

const Col2 = styled.div`
  flex: 50%;
  padding-left: 25px;
  @media (max-width: 678px) {
    padding-left: 0;
    flex-basis: 100%;
  }
`

const Col3 = styled.div`
  flex: 33.3%;
  @media (max-width: 678px) {
    order: 2;
    flex-basis: 100%;
  }
`

const Col4 = styled.div`
  flex: 66.6%;
  padding-left: 25px;
  @media (max-width: 678px) {
    order: 1;
    flex-basis: 100%;
    padding: 0;
  }
`

const Col5 = styled.div`
  flex: 60%;
  padding-right: 20px;
  @media (max-width: 678px) {
    flex-basis: 100%;
    padding: 0;
  }
`

const Col6 = styled.div`
  flex: 40%;
  @media (max-width: 678px) {
    flex-basis: 100%;
    padding: 0;
  }
`

const Ul = styled.ul`
  padding-left: 20px;
  list-style-type: square;
  @media (max-width: 678px) {
    margin: 0;
  }
`

const Li = styled.li`
  margin-bottom: 6px;
`
